'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore/underscore');
const svg4everybody = require('svg4everybody');

require('style.less');
const Router = require('./Router');
const Utils = require('utils/Utils.js');
const $ = require('jquery');
const objectFitImages = require('object-fit-images');
require('components/CommonText/CommonText.less');

/*eslint-disable */
const LazyLoad = require('vanilla-lazyload');
new LazyLoad({
    elements_selector: '.lazy',
    callback_loaded: function(node) {
        window.app.vent.trigger('image-loaded', node);
    }
});
/*eslint-enable */

svg4everybody();
window.$ = $;

const MobileDetect = require('mobile-detect');
require('mq-genie');

const promisePolyfill = require('promise-polyfill');

var FastClick = require('fastclick');
FastClick.attach(document.body);

if (!window.Promise) {
    window.Promise = promisePolyfill;
}

var isMac = window.navigator.userAgent.indexOf('Mac') !== -1;
const mobileDetect = new MobileDetect(window.navigator.userAgent);
const phone = mobileDetect.phone();
const tablet = mobileDetect.tablet();

window.app.settings.isDesktop = !phone && !tablet;
window.app.settings.isMobile = phone || tablet;
window.app.settings.isTablet = !!tablet;
window.app.settings.isPhone = !!phone;

document.documentElement.className += ' ' + (isMac ? 'isMac' : 'isNotMac');
document.documentElement.className += ' ' + (app.settings.isDesktop ? 'isDesktop' : 'isNotDesktop');
document.documentElement.className += ' ' + (!app.settings.isDesktop ? 'isMobile' : 'isNotMobile');
document.documentElement.className += ' ' + (app.settings.isTablet ? 'isTablet' : 'isNotTablet');
document.documentElement.className += ' ' + (app.settings.isPhone ? 'isPhone' : 'isNotPhone');

window.app.state = {};
window.app.vent = _.extend({}, Backbone.Events);
window.app.utils = Utils;
window.app.els = {};
window.app.views = {};

objectFitImages();

window.app.router = new Router();


$.fn.onCustom = function (eventName, callback) {
    this.each(function (ind, item) {
        var listeners = $(item).data('listeners');
        listeners && listeners[eventName] && listeners[eventName].push(callback);
    });

    return this;
};


$.fn.triggerCustom = function (eventName, options) {
    this.each(function (ind, item) {
        var listeners = $(item).data('listeners')[eventName];
        for (var i = 0 ; i < listeners.length; i++) {
            listeners[i]({}, options);
        }
    });

    return this;
};


$.fn.offCustom = function (eventName) {
    this.each(function (ind, item) {
        var listeners = $(item).data('listeners');
        listeners && listeners[eventName] && (listeners[eventName] = []);
    });

    return this;
};


$.easing.custom = function (x) {
    x--;

    return x * x * x + 1;
};


$.fn.flashClass = function (className, delay) {
    var self = this;
    var timeout;
    this.addClass(className);
    clearTimeout(this.data('timeout'));
    timeout = setTimeout(function () {
        if (typeof self === 'object' && self.length) {
            self.removeClass(className);
            self.data('timeout', null);
        }
    }, delay);
    this.data('timeout', timeout);

    return this;
};

